import API from "./server.api.js";

export const getQuest = `${API}/community/getQuest`;
export const uploadQuest = `${API}/community/uploadQuest`;
export const getAns = `${API}/community/getAns`;
export const uploadAns = `${API}/community/uploadAns`;
export const aiAnswer = `${API}/community/aiAnswer`;